import { styled } from "@mui/material";
import MuiDialogContent from "@mui/material/DialogContent";
import type { DialogContentProps } from "@mui/material/DialogContent";
import { useDialogContext } from "./Dialog";

const DialogContent = styled((props: DialogContentProps) => {
  const { children, ...rest } = props;
  const dialogContext = useDialogContext();
  return (
    <MuiDialogContent data-size={dialogContext.size} {...rest}>
      {children}
    </MuiDialogContent>
  );
})(({ theme }) => ({
  height: "100%",
  width: "100%",
  backgroundColor: "white",
  overflowY: "auto",
  /* Works in Chrome, Safari, Edge */
  "&::-webkit-scrollbar": {
    width: "16px",
  },

  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },

  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[60],
    borderRadius: "16px",
    border: "4px solid transparent",
    backgroundClip: "padding-box",
    minHeight: "30px",
  },

  "&[data-size=sm]": {
    padding: theme.spacing(3, 3, 0, 3),
  },
  "&[data-size=md]": {
    padding: theme.spacing(3, 3, 0, 3),
  },
  "&[data-size=lg]": {
    padding: theme.spacing(3, 4, 0, 4),
  },
}));

export default DialogContent;
